<div class="flex flex-column md:flex-row gap-4">

  <div class="flex-1">
    <p-table [scTableSettings]="tableSettings"
             [(selection)]="selectedChapter"
             (selectionChange)="onSelectionChange($event)">
      <ng-template pTemplate="tools-panel-left">
        @if (!isReadonly) {
          <p-button (onClick)="update()"
                    [disabled]="!canUpdate"
                    label="Update"
                    i18n-label>
          </p-button>
        }
      </ng-template>
    </p-table>
  </div>

  <cm-topic-picker [selected]="selectedTopicHeadings"
                   (selectedChange)="selectedTopicHeadings = $event"
                   [disabled]="isReadonly || !selectedChapter"
                   [hintText]="!selectedChapter && !isReadonly ? selectChapterHint : null">
  </cm-topic-picker>

</div>